module.exports = __webpack_public_path__ + "static/user-research-url-1-b531c47f4a46e2efed12f63ea69ef516.png";